import { useSearchParams } from 'next/navigation'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'

// Key for storing invite code in local storage (set on landing with ?invite=...)
const INVITE_CODE_STORAGE_KEY = 'dupe-invite-code'

export const useInviteCodeFromUrl = () => {
  const router = useRouter()
  const params = useSearchParams()
  const [inviteCode, setInviteCode] = useState<string>()

  const clearInviteCode = useCallback(() => {
    localStorage.removeItem(INVITE_CODE_STORAGE_KEY)
    setInviteCode(undefined)

    // remove invite code from url (using router)

    const newQuery = { ...router.query }
    delete newQuery.invite

    router.replace(
      {
        pathname: router.pathname,
        query: newQuery,
      },
      undefined,
      { shallow: true }
    )
  }, [router, setInviteCode])

  useEffect(() => {
    const code = params?.get('invite')

    if (code) {
      // Store the invite code in localStorage for later use in onboarding
      localStorage.setItem(INVITE_CODE_STORAGE_KEY, code)
      setInviteCode(code)
    }
  }, [params, setInviteCode])

  return { inviteCode, clearInviteCode }
}

export const getStoredInviteCode = (): string | null => {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(INVITE_CODE_STORAGE_KEY)
}

export const clearStoredInviteCode = () => {
  if (typeof window === 'undefined') return
  localStorage.removeItem(INVITE_CODE_STORAGE_KEY)
}

export default useInviteCodeFromUrl
